import styled from "styled-components";

const Image = styled.img`
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  border-style: none;
`;
export default Image;
